export default __webpack_public_path__ + "img/283353c934b719616adb3f76a92a395f.png";